import { render, staticRenderFns } from "./ProductAddNew.vue?vue&type=template&id=50c89ffc&"
import script from "./ProductAddNew.vue?vue&type=script&lang=js&"
export * from "./ProductAddNew.vue?vue&type=script&lang=js&"
import style0 from "./ProductAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports